import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import { MilestoneFragnetFilter } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/ActivityFragnet/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';

export const ActivityFragnet = ({ isSelected, onFiltersChanged }) => {
    const { control, trigger } = useFormContext<IFields>();
    return isSelected ? (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>Activity Fragnet</span>

            <Controller
                render={({ field }) => (
                    <MilestoneFragnetFilter
                        {...field}
                        onChange={async (newValue) => {
                            field.onChange(newValue);
                            const isValid = await trigger('activityForwardFragnet');
                            if (isValid) {
                                onFiltersChanged({ [field.name]: newValue });
                            }
                        }}
                    />
                )}
                name={'activityFragnet'}
                control={control}
            />
        </div>
    ) : null;
};
